export default () => {
  return (value, allValues) => {
    if (!allValues.initialDate || !value) return undefined
    if(value < allValues.initialDate){
      return 'ra.validation.endDate'
    }
    return undefined
  }
}
